import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'certificates',
      name: i18n.t('app.certificates'),
      path: 'certificates',
      use_parent_params: true,
      params_required: ['idEmpresa', 'serial', 'tipo'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'certificates/detail',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.companies_link'),
          path: 'certificates/companies',
          params,
          registerNavFromMenu: false,
          disabled: params.idEmpresa === -1 || params.idEmpresa === '-1' || params.serial === -1 || params.serial === '-1' || params.tipo === -1 || params.tipo === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.historical'),
          path: 'certificates/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.idEmpresa === -1 || params.idEmpresa === '-1' || params.serial === -1 || params.serial === '-1' || params.tipo === -1 || params.tipo === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
